'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ramda = require('ramda');

var _ramdaAdjunct = require('ramda-adjunct');

var _formatting = require('../utils/formatting');

var _templates = require('../utils/templates');

var renderDeclaration = function renderDeclaration(name, value) {
  return (0, _ramda.pipe)((0, _ramda.evolve)({
    name: _formatting.toKebabCase,
    value: (0, _ramda.compose)(_formatting.joinWithSpace, _ramdaAdjunct.ensureArray)
  }), _templates.createDeclarationFromTemplate)({ name: name, value: value });
};

exports.default = renderDeclaration;


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/renderers/renderDeclaration.js
// module id = 339
// module chunks = 168707334958949